import { render, staticRenderFns } from "./Chat-Bot.vue?vue&type=template&id=b413c460&scoped=true"
import script from "./Chat-Bot.vue?vue&type=script&lang=js"
export * from "./Chat-Bot.vue?vue&type=script&lang=js"
import style0 from "./Chat-Bot.vue?vue&type=style&index=0&id=b413c460&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b413c460",
  null
  
)

export default component.exports